import dayjs from "dayjs";

/* Extracts the leading number of days out of a plan's trialDuration string (e.g. "30 days" -> 30).
 * Falls back to 1 day (the legacy 24h-trial behaviour) when the field is missing or unparseable. */
export const parseTrialDurationDays = (trialDuration?: string | null): number => {
    const match = trialDuration?.match(/(\d+)/);
    return match ? Number(match[1]) : 1;
};

export const getTrialEndDate = (trialDays: number, isUSAUser?: boolean) => {
    const today = dayjs();
    const trialEnd = today.add(trialDays, "day");
    const formattedDate = trialEnd.format(isUSAUser ? "MM.DD.YYYY" : "DD.MM.YYYY");

    return formattedDate;
};

export const formatSecondsIntoMinutes = (totalSeconds: number): string => {
    return dayjs().hour(0).minute(0).second(totalSeconds).format("m:ss");
};
